import http from './http'

export const accounts = {
  me: () => http.get('accounts/me'),
}
